
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-loan-professionals",
      function () {
        return require("private-next-pages/business-loan-professionals/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-loan-professionals"])
      });
    }
  